import * as ReactDOM from 'react-dom/client'

export const mountReactNode = (reactNode: React.ReactNode, container: HTMLElement) => {
  const root = ReactDOM.createRoot(container);
  root.render(reactNode);

  return root;
};

export const initializeRootAndReturnRender = (container: HTMLElement) => {
  const root = ReactDOM.createRoot(container);

  return {
    root,
    render: (reactNode: React.ReactNode) => root.render(reactNode),
  };
};

export const unmountReactNode = (root: ReactDOM.Root) => {
  root.unmount();
};